// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_tech_benefit6_detail = /** @type {(inputs: {}) => string} */ () => {
	return `Air adapts to any surface. Tile, concrete, cobblestone — it doesn't matter.`
};

const el_tech_benefit6_detail = /** @type {(inputs: {}) => string} */ () => {
	return `Ο αέρας προσαρμόζεται σε κάθε επιφάνεια. Πλακάκια, σκυρόδεμα, καλντερίμι — δεν έχει σημασία.`
};

const ru_tech_benefit6_detail = /** @type {(inputs: {}) => string} */ () => {
	return `Воздух адаптируется к любой поверхности. Плитка, бетон, брусчатка — не имеет значения.`
};

const he_tech_benefit6_detail = /** @type {(inputs: {}) => string} */ () => {
	return `האוויר מתאים לכל משטח. אריחים, בטון, אבני ריצוף — לא משנה.`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "el" | "ru" | "he" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const tech_benefit6_detail = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.tech_benefit6_detail(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("tech_benefit6_detail", locale)
	if (locale === "en") return en_tech_benefit6_detail(inputs)
	if (locale === "el") return el_tech_benefit6_detail(inputs)
	if (locale === "ru") return ru_tech_benefit6_detail(inputs)
	if (locale === "he") return he_tech_benefit6_detail(inputs)
	return "tech_benefit6_detail"
};